import { StoveIcon } from './StoveIcon';

/**
 * author: Austin Andrews
 * id 18EF6E1E-8EF9-4A62-AAB9-6E8BE591408A
 * name stove
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stove.svg
 * tags
 * - Food / Drink 
 * - Home Automation 
 */
export const OvenIcon = StoveIcon;
export default OvenIcon